// extracted by mini-css-extract-plugin
export default {"title":"b61a05c2f5","inner_title":"f8c172b40c","charge_btn":"_2d210b072c"};